import { Typography, type TypographyProps } from "@mui/material";
import type { ReactNode } from "react";

export interface BreakableProps extends TypographyProps {
  children?: ReactNode;
  fallback?: ReactNode;
}

export function Breakable({
  children,
  fallback = "-",
  sx,
  ...props
}: BreakableProps) {
  return (
    <Typography
      component="span"
      sx={{
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        ...sx,
      }}
      {...props}
    >
      {children ?? fallback}
    </Typography>
  );
}
